"use client";

import { c as _c } from "react/compiler-runtime";
import DelegationCenterMenu from "@/components/delegation/DelegationCenterMenu";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
import { DelegationCenterSection } from "@/types/enums";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
export default function DelegationPageClient(props) {
  const $ = _c(27);
  useSetTitle("Delegation | 6529.io");
  const router = useRouter();
  const section = props.section;
  const [addressQuery, setAddressQuery] = useState(props.addressQuery ?? "");
  const [collectionQuery, setCollectionQuery] = useState(props.collectionQuery ?? "");
  const [useCaseQuery, setUseCaseQuery] = useState(props.useCaseQuery);
  let t0;
  if ($[0] !== addressQuery || $[1] !== collectionQuery || $[2] !== useCaseQuery) {
    t0 = function getQueryParams(s) {
      let queryParams = {};
      if (addressQuery && [DelegationCenterSection.CHECKER, DelegationCenterSection.ASSIGN_PRIMARY_ADDRESS].includes(s)) {
        queryParams = {
          address: addressQuery
        };
      }
      if (s === DelegationCenterSection.REGISTER_DELEGATION) {
        if (collectionQuery) {
          queryParams = {
            ...queryParams,
            collection: collectionQuery
          };
        }
        if (useCaseQuery) {
          queryParams = {
            ...queryParams,
            use_case: useCaseQuery
          };
        }
      }
      return queryParams;
    };
    $[0] = addressQuery;
    $[1] = collectionQuery;
    $[2] = useCaseQuery;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const getQueryParams = t0;
  const buildUrl = _temp;
  let t1;
  if ($[4] !== getQueryParams || $[5] !== props.path || $[6] !== router) {
    t1 = s_1 => {
      if (s_1) {
        if (![DelegationCenterSection.CHECKER, DelegationCenterSection.ASSIGN_PRIMARY_ADDRESS].includes(s_1)) {
          setAddressQuery("");
        }
        if (s_1 !== DelegationCenterSection.REGISTER_DELEGATION) {
          setCollectionQuery("");
          setUseCaseQuery(0);
        }
        if (s_1 === DelegationCenterSection.HTML && props.path) {
          router.push(`/delegation/${props.path.join("/")}`);
        } else {
          const queryParams_0 = getQueryParams(s_1);
          router.push(buildUrl(s_1, queryParams_0));
        }
      }
      window.scrollTo(0, 0);
    };
    $[4] = getQueryParams;
    $[5] = props.path;
    $[6] = router;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const updatePath = t1;
  let t2;
  if ($[8] !== getQueryParams || $[9] !== router) {
    t2 = s_2 => {
      if (s_2 === DelegationCenterSection.HTML) {
        return;
      }
      const queryParams_1 = getQueryParams(s_2);
      router.replace(buildUrl(s_2, queryParams_1));
    };
    $[8] = getQueryParams;
    $[9] = router;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const updateQueryParams = t2;
  let t3;
  if ($[11] !== section || $[12] !== updateQueryParams) {
    t3 = () => {
      updateQueryParams(section);
    };
    $[11] = section;
    $[12] = updateQueryParams;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== addressQuery || $[15] !== collectionQuery || $[16] !== useCaseQuery) {
    t4 = [addressQuery, collectionQuery, useCaseQuery];
    $[14] = addressQuery;
    $[15] = collectionQuery;
    $[16] = useCaseQuery;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  useEffect(t3, t4);
  let t5;
  if ($[18] !== updatePath) {
    t5 = s_3 => updatePath(s_3);
    $[18] = updatePath;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== addressQuery || $[21] !== collectionQuery || $[22] !== props.path || $[23] !== section || $[24] !== t5 || $[25] !== useCaseQuery) {
    t6 = <main className={styles.main}><DelegationCenterMenu section={section} path={props.path} setActiveSection={t5} address_query={addressQuery} setAddressQuery={setAddressQuery} collection_query={collectionQuery} setCollectionQuery={setCollectionQuery} use_case_query={useCaseQuery} setUseCaseQuery={setUseCaseQuery} /></main>;
    $[20] = addressQuery;
    $[21] = collectionQuery;
    $[22] = props.path;
    $[23] = section;
    $[24] = t5;
    $[25] = useCaseQuery;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}
function _temp(s_0, params) {
  const url = new URL(`/delegation/${s_0}`, window.location.origin);
  Object.entries(params).forEach(t0 => {
    const [k, v] = t0;
    return url.searchParams.set(k, String(v));
  });
  return url.pathname + url.search;
}